export default "__VITE_ASSET__C$l$Z7hn__"